<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<mat-card appearance="raised" class="mat-elevation-z1">
    <mat-card-content>
        <div class="logo-container">
            <div [ngClass]="{'okta-logo-light': (theme$ | async) === 'light', 'okta-logo-dark': (theme$ | async) === 'dark'}" alt="Okta Logo">
                <span class="logo"></span>
            </div>
        </div>
        <form [formGroup]="formGroup">
            <mat-form-field class="email-form-field" appearance="outline">
                <mat-label>{{'EMAIL' | translate}}</mat-label>
                <input id="username" matInput placeholder="{{'EMAIL' | translate}}" appAutofocus formControlName="email">
            </mat-form-field>
            <img class="sign-in-button" [src]="(theme$ | async) === 'dark' ? oktaButtonDarkPath : oktaButtonLightPath"
                 (click)="oktaLogin()" alt="Sign in with okta"/>
        </form>
        <div style="text-align: center">
            <h2>or</h2>
            <div class="back-to-cigent">
                <button mat-flat-button (click)="toggleSigIn()">{{'CIGENT_SIGN_IN' | translate}}</button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
